class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.quantityInput = this.form.querySelector('input[name="quantity"]');
    this.variantIdInput = this.form.querySelector('input[name="id"]');

    // Get all submit buttons that are part of the form
    this.submitButtons = document.querySelectorAll(
      `button[form="${this.form.getAttribute('id')}"]`
    );

    this.form.addEventListener('submit', (event) => this.onFormSubmit(event));

    this.unsubscribeVariantChange = subscribe(
      `variant:changed:${this.dataset.productId}`,
      ({ html }) => {
        const productForm = html.querySelector('product-form');
        this.replaceWith(productForm);
      }
    );

    // MOQ-Schutz: nur Mengen-Events des eigenen Produkts uebernehmen.
    // Ungescoped hat jeder Stepper der Seite (z.B. der PDP-Stepper unter dem offenen
    // Cart Drawer) nach cart:updated die versteckten Mengenfelder ALLER product-forms
    // ueberschrieben - so konnten Zubehoer-Adds im Drawer mit Menge 1 statt MOQ
    // in den Warenkorb gelangen.
    this.unsubscribeQuantityChange = subscribe('quantity:change', ({ quantity, productId }) => {
      if (String(productId) !== String(this.dataset.productId)) return;
      this.quantityInput.value = quantity;
    });
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange();
    this.unsubscribeQuantityChange();
  }

  /**
   * Handle form submission
   * @param {Event} event
   */
  async onFormSubmit(event) {
    event.preventDefault();
    this.toggleLoading(true);

    try {
      const formData = this.createFormData();
      await this.addToCart(formData);
      this.onSuccess();
    } catch (error) {
      this.onError(error);
    } finally {
      this.toggleLoading(false);
    }
  }

  /**
   * Toggle loading state on submit buttons
   * @param {boolean} loading
   */
  toggleLoading(loading) {
    this.submitButtons.forEach((button) => button.classList.toggle('loading', loading));
  }

  /**
   * Create form data
   * @returns {Object}
   */
  createFormData() {
    return {
      items: [
        {
          id: this.variantIdInput.value,
          quantity: this.quantityInput.value,
        },
      ],
    };
  }

  /**
   * Add to cart
   * @param {Object} formData
   * @returns {Object}
   */
  async addToCart(formData) {
    const response = await fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Failed to add to cart');
    return data;
  }

  /**
   * Handle form success
   */
  onSuccess() {
    publish('cart:added', {
      productId: this.dataset.productId,
      variantId: this.variantIdInput.value,
    });
  }

  /**
   * Handle form error
   * @param {Error} error - The error object
   */
  onError({ message }) {
    console.error(message);

    // Ensure there's at least one focusable element for focus-trap
    const submitButton = this.submitButtons[0];
    if (submitButton) {
      submitButton.focus();
    }

    window.toast.error(message);
  }
}

customElements.define('product-form', ProductForm);